import React from 'react';
import '../index.css';

const About = () => {
  return (
    <div className="container" style={{ maxWidth: '900px', margin: '0 auto', padding: '40px 20px' }}>
      <div style={{ 
        textAlign: 'center', 
        marginBottom: '50px',
        animation: 'fadeInUp 0.6s ease-out'
      }}>
        <h1 style={{
          color: 'var(--text-accent)',
          fontSize: '42px',
          fontWeight: '800',
          marginBottom: '16px',
          textTransform: 'uppercase',
          letterSpacing: '2px'
        }}>
          About GamersUnion
        </h1>
        <p style={{
          color: 'var(--text-secondary)',
          fontSize: '18px',
          lineHeight: '1.6'
        }}>
          One place for gamers, developers, and creators to help each other out
        </p>
      </div>

      <div style={{
        backgroundColor: 'var(--card-bg)',
        borderRadius: '16px',
        padding: '40px',
        border: '1px solid var(--border)',
        lineHeight: '1.8',
        fontSize: '16px',
        animation: 'fadeInUp 0.8s ease-out'
      }}>
        
        <section style={{ marginBottom: '40px' }}>
          <h2 style={{ 
            color: 'var(--text-accent)', 
            fontSize: '28px', 
            fontWeight: '700',
            marginBottom: '20px',
            borderBottom: '3px solid var(--primary)',
            paddingBottom: '10px'
          }}>
            Why I Built This
          </h2>
          <p style={{ color: 'var(--text)', marginBottom: '16px' }}>
            I created GamersUnion because I kept seeing the same problems everywhere. Indie developers couldn't get 
            their games noticed. Gamers had a hard time finding good indie titles. Content creators struggled to grow 
            their audience. Everyone was dealing with these issues alone.
          </p>
          <p style={{ color: 'var(--text)', marginBottom: '16px' }}>
            So I built this platform as one place where everyone can actually help each other. If you're a developer, 
            you can show off your game and get real feedback. If you're a gamer, you can find great indie games and 
            earn rewards for being active. If you're a creator, you can connect with people who care about what you do.
          </p>
        </section>

        <section style={{ marginBottom: '40px' }}>
          <h2 style={{ 
            color: 'var(--text-accent)', 
            fontSize: '28px', 
            fontWeight: '700',
            marginBottom: '20px',
            borderBottom: '3px solid var(--primary)',
            paddingBottom: '10px'
          }}>
            What's Here
          </h2>
          
          <div style={{ marginBottom: '24px' }}>
            <h3 style={{ 
              color: 'var(--primary)', 
              fontSize: '20px', 
              fontWeight: '600',
              marginBottom: '12px',
              display: 'flex',
              alignItems: 'center',
              gap: '10px'
            }}>
              🎮 For Gamers
            </h3>
            <p style={{ color: 'var(--text)', marginBottom: '12px' }}>
              You can discover indie games, join giveaways, and earn points for being active. Write reviews, engage 
              with posts, help other members, you get points for all of it. Use those points in the shop to get game 
              keys and other stuff. There's also curated gaming news and a community where people actually care about 
              real engagement, not just follower counts.
            </p>
          </div>

          <div style={{ marginBottom: '24px' }}>
            <h3 style={{ 
              color: 'var(--primary)', 
              fontSize: '20px', 
              fontWeight: '600',
              marginBottom: '12px',
              display: 'flex',
              alignItems: 'center',
              gap: '10px'
            }}>
              👨‍💻 For Indie Developers
            </h3>
            <p style={{ color: 'var(--text)', marginBottom: '12px' }}>
              I know how hard it is to get your game noticed. Here you can showcase your game to people who actually 
              want to discover indie titles. Host giveaways to create some hype, get feedback through reviews, and 
              talk directly with players. You can track how your game is doing and get resources on marketing and 
              community stuff. No gatekeepers, you're in control. Just you and players who genuinely care about indie games.
            </p>
          </div>

          <div style={{ marginBottom: '24px' }}>
            <h3 style={{ 
              color: 'var(--primary)', 
              fontSize: '20px', 
              fontWeight: '600',
              marginBottom: '12px',
              display: 'flex',
              alignItems: 'center',
              gap: '10px'
            }}>
              🎬 For Content Creators
            </h3>
            <p style={{ color: 'var(--text)', marginBottom: '12px' }}>              Showcase your content, find new games before they blow up, work with indie developers on sponsored stuff 
              or early access, and grow your audience through an actually engaged community. Easy to connect with 
              developers who need coverage and gamers looking for new channels to follow.
            </p>
          </div>
        </section>

        <section style={{ marginBottom: '40px' }}>
          <h2 style={{ 
            color: 'var(--text-accent)', 
            fontSize: '28px', 
            fontWeight: '700',
            marginBottom: '20px',
            borderBottom: '3px solid var(--primary)',
            paddingBottom: '10px'
          }}>
            The Story
          </h2>
          <p style={{ color: 'var(--text)', marginBottom: '16px' }}>
            I started GamersUnion as a side project because I was frustrated. As an indie developer, I saw how hard 
            it was to get games noticed. Big marketing budgets won, not necessarily the best games. I couldn't find 
            the right platforms to connect with players who actually cared. So I built this, a place where quality 
            matters and genuine engagement gets rewarded.
          </p>
          <p style={{ color: 'var(--text)', marginBottom: '16px' }}>
            It started simple, just a showcase for indie games. Now it's grown into giveaways, reviews, community cards, 
            news, reward systems, and more. Every feature I add comes from feedback from people here. I'm building 
            what you actually need, not what I think sounds cool.
          </p>
          <p style={{ color: 'var(--text)', marginBottom: '16px' }}>
            This site is independent. No investors. Just community support through donations and partnerships that 
            make sense. That means I can make decisions based on what's best for everyone here, not what makes the 
            most money.
          </p>
        </section>

        <section style={{ marginBottom: '40px' }}>
          <h2 style={{ 
            color: 'var(--text-accent)', 
            fontSize: '28px', 
            fontWeight: '700',
            marginBottom: '20px',
            borderBottom: '3px solid var(--primary)',
            paddingBottom: '10px'
          }}>
            What I Believe In
          </h2>
          
          <div style={{ marginBottom: '16px' }}>
            <h4 style={{ color: 'var(--primary)', fontSize: '18px', fontWeight: '600', marginBottom: '8px' }}>
              Community First
            </h4>
            <p style={{ color: 'var(--text)' }}>
              Every decision I make is about what's best for this community. I listen to feedback, add features 
              people ask for, and try to be transparent about where things are going and what's challenging.
            </p>
          </div>

          <div style={{ marginBottom: '16px' }}>
            <h4 style={{ color: 'var(--primary)', fontSize: '18px', fontWeight: '600', marginBottom: '8px' }}>
              Fair & Clear
            </h4>
            <p style={{ color: 'var(--text)' }}>
              Clear rules, fair moderation, no hidden tricks. The points system rewards real engagement. The 
              giveaway system gives everyone a fair shot. That's it.
            </p>
          </div>

          <div style={{ marginBottom: '16px' }}>
            <h4 style={{ color: 'var(--primary)', fontSize: '18px', fontWeight: '600', marginBottom: '8px' }}>
              Quality Over Numbers
            </h4>
            <p style={{ color: 'var(--text)' }}>
              I'd rather have a small, active community than tons of inactive accounts. Quality games, real reviews, 
              and genuine conversations are what make this place special.
            </p>
          </div>

          <div style={{ marginBottom: '16px' }}>
            <h4 style={{ color: 'var(--primary)', fontSize: '18px', fontWeight: '600', marginBottom: '8px' }}>
              Keep It Safe
            </h4>
            <p style={{ color: 'var(--text)' }}>
              I work to keep this a welcoming place. There's a scammer database to protect people from fraud. Reports 
              get handled quickly. Zero tolerance for harassment. Simple.
            </p>
          </div>
        </section>

        <section>
          <h2 style={{ 
            color: 'var(--text-accent)', 
            fontSize: '28px', 
            fontWeight: '700',
            marginBottom: '20px',
            borderBottom: '3px solid var(--primary)',
            paddingBottom: '10px'
          }}>
            Come Join
          </h2>
          <p style={{ color: 'var(--text)', marginBottom: '16px' }}>
            GamersUnion is still growing, and I'd love for you to be part of it. Whether you want to discover indie 
            games, show off your own game, or just hang out with people who actually care about gaming, there's a 
            place for you here.
          </p>
          <p style={{ color: 'var(--text)', marginBottom: '16px' }}>
            Make a free account and start exploring. Say hi in the community cards, join some giveaways, write reviews, 
            earn points, and help shape where this goes next. I'm building this for you, so your input really matters.
          </p>
          <p style={{ color: 'var(--text)', fontStyle: 'italic', fontSize: '18px', textAlign: 'center', marginTop: '32px' }}>
            Welcome to GamersUnion 🎮
          </p>
        </section>

      </div>

      <div style={{
        textAlign: 'center',
        marginTop: '50px',
        padding: '30px',
        backgroundColor: 'var(--card-bg)',
        borderRadius: '16px',
        border: '1px solid var(--border)'
      }}>
        <h3 style={{ color: 'var(--text-accent)', fontSize: '24px', marginBottom: '16px' }}>
          Support This Site
        </h3>
        <p style={{ color: 'var(--text)', marginBottom: '20px', fontSize: '16px' }}>
          I build and run this site solo. If you like what I'm doing here, consider supporting via donation!
        </p>
        <a 
          href="https://razorpay.me/@alonelycat" 
          target="_blank" 
          rel="noopener noreferrer"
          style={{
            display: 'inline-block',
            padding: '12px 30px',
            backgroundColor: 'var(--primary)',
            color: 'white',
            borderRadius: '8px',
            textDecoration: 'none',
            fontWeight: '600',
            fontSize: '16px',
            transition: 'all 0.3s ease'
          }}
        >
          💳 Donate via Razorpay
        </a>
      </div>
    </div>
  );
};

export default About;
